<template>
	<div class="login-wrap">
		<div class="back-wrap" @click="toHome">返回首页</div>
		<div class="login">
			<div class="login-top" v-if="type == 1">
				<img src="../assets/images/logo1.png" alt="" />
				<img src="../assets/images/login_icon2.png" alt="" />
			</div>
			<div class="login-top" v-if="type == 2">
				<img src="../assets/images/logo1.png" alt="" />
				<img src="../assets/images/login_icon1.png" alt="" />
			</div>
			<div class="login-top" v-if="type == 3">
				<img src="../assets/images/logo1.png" alt="" />
				<img src="../assets/images/login_icon3.png" alt="" />
			</div>
			<div class="login-bottom" v-if="type == 1">
				<div class="d-flex d-align-center input-wrap">
					<div class="left">
						<img src="../assets/images/login_idcard.png" alt="" />
					</div>
					<input type="text" v-model="idCard" placeholder="请输入身份证号">
				</div>
				<div class="d-flex d-align-center input-wrap">
					<div class="left">
						<img src="../assets/images/login_pass.png" alt="" />
					</div>
					<input type="password" v-model="password" placeholder="请输入密码">
				</div>
        <div class="tishi">* 密码为身份证后六位</div>
				<div class="btn">
					<button @click="toLogin">登  录</button>
				</div>
			</div>
			<div class="login-bottom" v-if="type == 2">
				<div class="d-flex d-align-center input-wrap">
					<div class="left">
						<img src="../assets/images/login_idcard.png" alt="" />
					</div>
					<input type="text" v-model="idCard" placeholder="请输入身份证号">
				</div>
				<div class="d-flex d-align-center input-wrap">
					<div class="left">
						<img src="../assets/images/login_pass.png" alt="" />
					</div>
					<input type="text" v-model="password" placeholder="请输入密码">
				</div>
				<div class="btn">
					<button @click="toLogin">登  录</button>
				</div>
			</div>
			<div class="login-bottom" v-if="type == 3">
				<div class="d-flex d-align-center input-wrap">
					<div class="left">
						<img src="../assets/images/login_num.png" alt="" />
					</div>
					<input type="text" v-model="xuehao" placeholder="请输入学号">
				</div>
				<div class="btn" >
					<button @click="toLogin">查  询</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {Base64} from 'js-base64';
	import {
		account,
    find_chengji
	} from "@/api/index";
	export default {
		name: "login",
		data() {
			return {
				idCard: '',
				password: '',
				type:1,
        xuehao:''
			}
		},
		mounted() {
      this.type = this.$route.query.type
      if (this.$route.query.encodedText) {
        let decodedText = Base64.decode(this.$route.query.encodedText);
        this.toLogin1(JSON.parse(decodedText))
      }
		},
		methods:{
			toHome(){
				this.$router.push({
				  path: '/'
				})
			},
      toLogin1(decodedText){
        let ajaxData = {
          account: decodedText.idCard,
          password: decodedText.password,
          scene:1
        }
        account(ajaxData).then(res => {
          if (res.code == 1) {
            localStorage.setItem('idcard',res.data.idcard)
            localStorage.setItem('name',res.data.name)
            localStorage.setItem('sex',res.data.sex)
            localStorage.setItem('token',res.data.token)
            this.$bus.$emit('setName', {
              data: res.data.name
            })
            if (this.type == 1) {
              this.$router.push({
                path: '/myCourseList'
              })
            }else {
              this.$router.push({
                path: '/examList'
              })
            }
          }else {
            this.$message.error(res.msg)
          }
        })
      },
			toLogin(){
			  if ( this.type == 1 || this.type == 2) {
          if ( !this.idCard ) {
            this.$message.warning('请输入身份证号')
            return
          }
          // if (!this.validateID(this.idCard)) {
          //   this.$message.warning('身份证号码格式不正确，请检查后重新输入!')
          //   return
          // }
          if ( !this.password ) {
            this.$message.warning('请输入密码')
            return
          }
          let ajaxData = {
            account: this.idCard,
            password: this.password,
            scene:1
          }
          account(ajaxData).then(res => {
            if (res.code == 1) {
              localStorage.setItem('idcard',res.data.idcard)
              localStorage.setItem('name',res.data.name)
              localStorage.setItem('sex',res.data.sex)
              localStorage.setItem('token',res.data.token)
              this.$bus.$emit('setName', {
                data: res.data.name
              })
              if (this.type == 1) {
                this.$router.push({
                  path: '/myCourseList'
                })
              }else {
                this.$router.push({
                  path: '/examList'
                })
              }
            }else {
              this.$message.error(res.msg)
            }
          })
        }else{
          let ajaxData = {
            xuehao:this.xuehao
          }
          find_chengji(ajaxData).then(res => {
            if (res.code == 1) {
              if (!res.data.length) {
                this.$message.error('暂无考试内容')
                return
              }
              this.$router.push({
                path: '/performance',
                query:{
                  xuehao:this.xuehao
                }
              })
            }else {
              this.$message.error(res.msg)
            }
          })
        }
			},
      validateID(id) {
        const regIdNo = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
        return regIdNo.test(id);
      }
		}
	}
</script>

<style scoped lang="scss">
	.login-wrap {
		background-image: url("../assets/images/login_bj.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;

		.back-wrap{
			cursor: pointer;
			position: absolute;
			right: 50px;
			top: 30px;
			padding: 10px 30px;
			border-radius: 20px;
			border: 1px solid #fff;
			color: #fff;
		}

		.login {
			width: 500px;
			.login-top{
				background-image: url(../assets/images/login_title.png);
				background-repeat: no-repeat;
				background-size: 100% 100%;
				width: 100%;
				height: 150px;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				img:nth-child(1){
					margin-bottom: 20px;
				}
			}
			.login-bottom{
				background-color: #fff;
				border-radius: 0 0 15px 15px;
				padding: 50px 50px;
				.input-wrap{
					margin-bottom: 20px;
					.left{
						display: flex;
						align-items: center;
						justify-content: center;
						border-radius: 6px 0 0 6px;
						background-color: #1f8ba7;
						width: 80px;
						height: 54px;
						img{
							width: 30px;
							height: 30px;
						}
					}
					input{
						height: 54px;
						flex: 1;
						background-color: #e5eff1;
						border-radius: 0 6px 6px 0;
						padding-left: 20px;
					}
				}
				.btn{
					margin-top: 40px;
					background-color: #1f8ba7;
					height: 54px;
					border-radius: 28px;
					display: flex;
					justify-content: center;
					align-items: center;
					width: 100%;
					button{
						width: 100%;
						height: 100%;
						font-weight: bold;
						font-size: 20px;
						color: #fff;
					}
				}
			}
		}
	}
  .tishi{
    color: red;
    font-size: 12px;
  }
</style>
